import PhilospyImage from "../../../assets/chef_checking_ingredient.jpg"

const Philosophy = ({t}) => {
    return (
        <section className="container mx-auto px-4 py-16">
            <div className="flex flex-col md:flex-row gap-8">
                {/* Left Column */}
                <div className="md:w-1/2 flex flex-col justify-center">
                    <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{t?.title}</h5>
                    <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{t?.subTitle}</h2>
                    <p className="mb-6 text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">{t?.description1}</p>
                    <p className="mb-6 text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">{t?.description2}</p>
                </div>
                {/* Right Column */}
                <div className="md:w-1/2 relative">
                    <img 
                        src={PhilospyImage}
                        alt="Chef Luca Fantin"
                        width={600}
                        height={650}
                        className="w-full h-[650px] object-cover"
                    />
                </div>
            </div>
        </section>
    )
}

export default Philosophy;